import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid } from '@hbf/dsl';

import {
  DateInput,
  DatePickerInputsProps,
} from '@ha/marketplace/feature-date-picker';

const useStyles = makeStyles()(theme => ({
  inputFromWrapper: {
    marginRight: theme.spacing(2),
  },
  inputWrapper: {
    flexGrow: 1,
  },
}));

const SearchDateRangePickerInputs: React.FC<DatePickerInputsProps> = props => {
  const { classes, cx } = useStyles();

  const {
    from,
    fromInputProps,
    isFromFocused,
    onFromFocus,
    to,
    toInputProps,
    isToFocused,
    onToFocus,
  } = props;

  return (
    <Grid container justifyContent="space-between" wrap="nowrap">
      <Grid item className={cx(classes.inputWrapper, classes.inputFromWrapper)}>
        <DateInput
          {...fromInputProps}
          dateValue={from}
          onInputClick={onFromFocus}
          focused={isFromFocused}
        />
      </Grid>
      <Grid item className={classes.inputWrapper}>
        <DateInput
          {...toInputProps}
          dateValue={to}
          onInputClick={onToFocus}
          focused={isToFocused}
        />
      </Grid>
    </Grid>
  );
};

export { SearchDateRangePickerInputs };
